/**
 * 网友评价库（批 C 功能先行版，设计=docs/新增功能-年度奖项与网友评价.md §5 + docs/评价库文案填写表.md）。
 *
 * ⚠️ **本表已全是正式文案**：颜值 28＋演技 29＋咖位 30＋口碑 22＝**109 条**，
 * 2026-10-06 由 `docs/评价库文案填写表.md` 整面导入；颜值/演技/咖位/口碑四面＝**用户口述逐字照录**
 * （咖位＝10-07 起逐桶改写；🚨 **10-08 咖位 T3 整桶翻案重写**＝该桶原六句是**我起草、被我错记成"用户亲笔"**，
 * 　用户翻自己记录重贴六句 ⇒ 现 T3 才算亲笔；同批我把全表 109 句"口述"标注列给他逐条复核，他回
 * 　「**别的都没问题**」⇒ 其余四桶归属成立、**错记只此一处**（见填写表 §16 与设计侧报告 §8.106~§8.107）；
 * 　口碑＝10-07 四桶亲笔，⚠️ **T3（−100~100）那一档⛔ 设文案**——
 * 用户「算了口碑-100~100就不设评价吧，感觉没什么好评的」⇒ 档位照旧算得出、组池筛出 0 条属设计内）。
 * 🚨 **事件桶（原 `RV-EV-*` 30 条）2026-10-07 整块下线**＝文案加判据全删，理由见下面事件桶那段注释。
 * 🚨 **近作面（原 `RV-NR-*` 18 条）2026-10-31 整块下线**（茄子令「删掉近作反响的评价，网友评价里不显示这档」）
 * ＝18 条文案、`face:'near'`/`NearBand`/`nearBand` 字段、ReviewSystem.nearBandOf 分格与组池一并删
 * （文案原文在 git 历史，填写表 §24 同步撤）。
 *
 * 结构：
 *  - face：所属面（抽取按玩家档位筛）
 *  - band：属性面档位 T1~T5（颜值气质/演技：阈值 100/200/300/400；咖位面：rank 2~3/4~5/6~7/8~9/10 独占；
 *    口碑面：显示值 −500~500，边界 −300／−100／101／301 ⇒ T3 为⛔ 文案的空档）
 *
 * ⚠️ **2026-10-06 用户令「说话人全用随机网友」**：`speaker` 字段连同 P1~P5 五个人设**整条删除**
 * （一列全是同一个值＝死信息）。原先挂在 `speaker === 'P5'` 上的两条「观众」准入随事件桶下线。
 * 显示名当前一律＝`REVIEWER_DISPLAY_NAME`（momo，同日追改），随机网名池原地当存货、⛔ 上屏。
 */
import { ScriptGenre } from '../types';

export type ReviewFace = 'look' | 'act' | 'fame' | 'rep';

export interface ReviewEntry {
    id: string;
    face: ReviewFace;
    /** 属性面档位（face=look/act/fame/rep 时必填） */
    band?: 1 | 2 | 3 | 4 | 5;
    /** 支持的剧本类型（空 = 全类型通吃；测试文案不填） */
    genres?: ScriptGenre[];
    text: string;
}

/**
 * ⚠️ **2026-10-06 同日追改（用户令「先让所有的网友名字都叫 momo，已经取好的⛔ 删，先放那儿吧」）**：
 * 面板上的昵称一律显示 `momo`（评论区一排同名的人＝真实的默认网名现象），下面这 30 个网名**原地留着待恢复**，
 * 恢复随机网名＝把 `ReviewSystem.pickReviews()` 里那句 `speaker: REVIEWER_DISPLAY_NAME` 换回从池子抽（同批⛔ 重名的领用逻辑见报告 §8.90）。
 */
export const REVIEWER_DISPLAY_NAME = 'momo';

/**
 * 随机网名池（**当前⛔ 上屏**，见上面 `REVIEWER_DISPLAY_NAME` 那条追改；留着当恢复时的存货）。
 * ⚠️ 这 30 个名字**全＝AI 起、用户从没逐条过**；10-08 同一句口令「近作反响和随机网名先用你取的吧，最后再改」⇒ 状态＝**暂用 AI 版**，⛔ 当"已确认"。
 * 两路混排：**生活流 ID 为主**（像真人随手起的名字）+ **少量梗型**（一眼是路人）。
 * 纪律＝⛔ emoji、⛔ 真人演员名、⛔ 平台名（与文案同一条线）。想换口味只改这里，⛔ 动文案表。
 */
export const REVIEW_RANDOM_NAMES = [
    // 生活流 ID
    '小赵不睡觉', '芒果干三分甜', '周三下午三点', '阿芷的红豆汤', '把月亮关掉',
    '别卷了睡吧', '六楼住户', '柠檬茶去冰', '排队买豆浆', '两点半的猫',
    '半糖不加冰', '早八人自救', '冰箱里的灯', '走神的乘客', '六点半的公交',
    '一颗板栗', '阳台上的绿萝', '隔壁工位的键盘', '只追剧不打分', '下班路过的风',
    // 梗型
    '吃瓜群众甲', '路过的谁', '匿名吃瓜', '潜水十级', '热搜划水员',
    '第八个路人', '前排蹲一个', '摸鱼观摩中', '专业路人三十年', '今晚不追剧',
];

export const NETIZEN_REVIEWS: ReviewEntry[] = [
    // ===== 颜值气质面（T1~T5，**正式文案 28 条**＝2026-10-06 用户亲写、填写表已导）=====
    { id: 'RV-LOOK-T1-1', face: 'look', band: 1, text: '长这样的都能当演员吗？' },
    { id: 'RV-LOOK-T1-2', face: 'look', band: 1, text: '说她普都是抬举了' },
    { id: 'RV-LOOK-T1-3', face: 'look', band: 1, text: '丑我一跳' },
    { id: 'RV-LOOK-T1-4', face: 'look', band: 1, text: '哪来的资本家丑孩子' },
    { id: 'RV-LOOK-T2-1', face: 'look', band: 2, text: '也就精修能看' },
    { id: 'RV-LOOK-T2-2', face: 'look', band: 2, text: '只有我一个人觉得%玩家名%很普吗' },
    { id: 'RV-LOOK-T2-3', face: 'look', band: 2, text: '看见%玩家名%粉吹颜值就想笑。。。吃点好的吧。。。' },
    { id: 'RV-LOOK-T2-4', face: 'look', band: 2, text: '只能说放素人里算小美女' },
    { id: 'RV-LOOK-T2-5', face: 'look', band: 2, text: '长得很寡淡，很难记住这张脸' },
    { id: 'RV-LOOK-T2-6', face: 'look', band: 2, text: '她长得特像我们公司前台' },
    { id: 'RV-LOOK-T3-1', face: 'look', band: 3, text: '说不出哪好但看着挺舒服的' },
    { id: 'RV-LOOK-T3-2', face: 'look', band: 3, text: '有辨识度但算不上大美女' },
    { id: 'RV-LOOK-T3-3', face: 'look', band: 3, text: '挺好看的但演女主感觉不太够格吧' },
    { id: 'RV-LOOK-T3-4', face: 'look', band: 3, text: '不是第一眼美女但越看越好看' },
    { id: 'RV-LOOK-T3-5', face: 'look', band: 3, text: '她的美需要角色加持' },
    { id: 'RV-LOOK-T3-6', face: 'look', band: 3, text: '她适合走气质路线，别硬吹神颜' },
    { id: 'RV-LOOK-T3-7', face: 'look', band: 3, text: '反正我很吃她的颜' },
    { id: 'RV-LOOK-T3-8', face: 'look', band: 3, text: '很适合演白月光的长相' },
    { id: 'RV-LOOK-T4-1', face: 'look', band: 4, text: '没有香气的花' },
    { id: 'RV-LOOK-T4-2', face: 'look', band: 4, text: '完全生图杀手来的' },
    { id: 'RV-LOOK-T4-3', face: 'look', band: 4, text: '看她小时候照片就是从小美到大啊，天生吃这碗饭的羡慕不来' },
    { id: 'RV-LOOK-T4-4', face: 'look', band: 4, text: '美得很客观' },
    { id: 'RV-LOOK-T4-5', face: 'look', band: 4, text: '说%玩家名%整容的建议看看人家爸妈年轻时的照片，基因骗不了人' },
    { id: 'RV-LOOK-T4-6', face: 'look', band: 4, text: '姐就这样硬美' },
    { id: 'RV-LOOK-T5-1', face: 'look', band: 5, text: '女娲毕设' },
    { id: 'RV-LOOK-T5-2', face: 'look', band: 5, text: '为国争光的美貌' },
    { id: 'RV-LOOK-T5-3', face: 'look', band: 5, text: '我说亚颜一是%玩家名%谁赞成谁反对' },
    { id: 'RV-LOOK-T5-4', face: 'look', band: 5, text: '公认内娱颜值天花板' },

    // ===== 演技面（T1~T5，**正式文案 29 条**＝2026-10-06 用户亲写、填写表已导；T1 比方案甲多 1 条）=====
    { id: 'RV-ACT-T1-1', face: 'act', band: 1, text: '笑得比哭还难看' },
    { id: 'RV-ACT-T1-2', face: 'act', band: 1, text: 'ai演员都比她有情绪' },
    { id: 'RV-ACT-T1-3', face: 'act', band: 1, text: '%玩家名%的演技值得一个金扫帚终身成就奖' },
    { id: 'RV-ACT-T1-4', face: 'act', band: 1, text: '%玩家名%这样的演技为什么还能有戏拍？？？' },
    { id: 'RV-ACT-T1-5', face: 'act', band: 1, text: '只会瞪眼抿嘴皱眉三件套' },
    { id: 'RV-ACT-T2-1', face: 'act', band: 2, text: '%玩家名%演技不出戏，但看多了发现全是一个套路' },
    { id: 'RV-ACT-T2-2', face: 'act', band: 2, text: '她不是不会演，是不愿意出舒适区' },
    { id: 'RV-ACT-T2-3', face: 'act', band: 2, text: '演谁都像自己' },
    { id: 'RV-ACT-T2-4', face: 'act', band: 2, text: '她只适合人设贴脸的角色，离开舒适区就露馅' },
    { id: 'RV-ACT-T2-5', face: 'act', band: 2, text: '三个角色剪一起粉丝都分不清谁是谁，同质化到可以消消乐' },
    { id: 'RV-ACT-T2-6', face: 'act', band: 2, text: '预制菜演技，加热即食，味道稳定，但没有锅气' },
    { id: 'RV-ACT-T3-1', face: 'act', band: 3, text: '配角还挺有记忆点的，一担主角就撑不住戏了' },
    { id: 'RV-ACT-T3-2', face: 'act', band: 3, text: '镜头少反而惊艳，镜头一多就露怯' },
    { id: 'RV-ACT-T3-3', face: 'act', band: 3, text: '导演会拍的话也能出彩' },
    { id: 'RV-ACT-T3-4', face: 'act', band: 3, text: '她的进步是看得见的，每部戏都有在变好' },
    { id: 'RV-ACT-T3-5', face: 'act', band: 3, text: '给%玩家名%好对手、好导演、好角色，她是可以给观众惊喜的。' },
    { id: 'RV-ACT-T3-6', face: 'act', band: 3, text: '之前那部剧她的哭戏我是真共情了' },
    { id: 'RV-ACT-T3-7', face: 'act', band: 3, text: '新剧里和老戏骨对戏也没有被压' },
    { id: 'RV-ACT-T3-8', face: 'act', band: 3, text: '我一直觉得她是有天赋的，只是缺少历练' },
    { id: 'RV-ACT-T4-1', face: 'act', band: 4, text: '她的戏值得反复看' },
    { id: 'RV-ACT-T4-2', face: 'act', band: 4, text: '%玩家名%是我开会员的理由' },
    { id: 'RV-ACT-T4-3', face: 'act', band: 4, text: '现在像%玩家名%这种一人千面的演员太稀缺了' },
    { id: 'RV-ACT-T4-4', face: 'act', band: 4, text: '她的演技一直被低估了，这样的实力应该被更多人看见' },
    { id: 'RV-ACT-T4-5', face: 'act', band: 4, text: '她演什么都像是真的' },
    { id: 'RV-ACT-T4-6', face: 'act', band: 4, text: '她缺的是机会，不是实力' },
    { id: 'RV-ACT-T5-1', face: 'act', band: 5, text: '国宝级演员' },
    { id: 'RV-ACT-T5-2', face: 'act', band: 5, text: '教科书级别的演技' },
    { id: 'RV-ACT-T5-3', face: 'act', band: 5, text: '把奖颁给她没人不服' },
    { id: 'RV-ACT-T5-4', face: 'act', band: 5, text: '她的演技没人质疑' },

    // ===== 咖位/资源面（T1~T5，**30 条＝五桶全由用户亲笔定稿 2026-10-07**；档位＝Lv.2~3/4~5/6~7/8~9/10 独占；条数＝下限，T4/T5 各加过 1 句）=====
    { id: 'RV-FAME-T1-1', face: 'fame', band: 1, text: '这谁' },
    { id: 'RV-FAME-T1-2', face: 'fame', band: 1, text: '不认识' },
    { id: 'RV-FAME-T1-3', face: 'fame', band: 1, text: '百科介绍写得像群演履历' },
    { id: 'RV-FAME-T1-4', face: 'fame', band: 1, text: '查无此人' },
    { id: 'RV-FAME-T1-5', face: 'fame', band: 1, text: '这知名度和素人有什么区别' },
    { id: 'RV-FAME-T1-6', face: 'fame', band: 1, text: '不就是个跑龙套的吗' },
    { id: 'RV-FAME-T1-7', face: 'fame', band: 1, text: '现在糊不代表以后糊，支持姐姐，我先买股了' },
    { id: 'RV-FAME-T1-8', face: 'fame', band: 1, text: '伟大的新人美时期' },
    { id: 'RV-FAME-T2-1', face: 'fame', band: 2, text: '有点眼熟，但说不出名字' },
    { id: 'RV-FAME-T2-2', face: 'fame', band: 2, text: '在不少剧里见过她' },
    { id: 'RV-FAME-T2-3', face: 'fame', band: 2, text: '离一线差一部爆款，离糊差一口气' },
    { id: 'RV-FAME-T2-4', face: 'fame', band: 2, text: '待爆待了几年，花都谢了' },
    { id: 'RV-FAME-T2-5', face: 'fame', band: 2, text: '有姓名没排面，有角色没得挑' },
    { id: 'RV-FAME-T2-6', face: 'fame', band: 2, text: '糊咖一个' },
    { id: 'RV-FAME-T3-1', face: 'fame', band: 3, text: '粉丝控评是真的强，评论前排全是“期待%玩家名%”“演员%玩家名%未来可期”' },
    { id: 'RV-FAME-T3-2', face: 'fame', band: 3, text: '我上次评论了句台词有点糊，五分钟被骂了八条' },
    { id: 'RV-FAME-T3-3', face: 'fame', band: 3, text: '我表妹是%玩家名%铁粉天天给她做数据' },
    { id: 'RV-FAME-T3-4', face: 'fame', band: 3, text: '路人盘不怎么样，国民度有待提升' },
    { id: 'RV-FAME-T3-5', face: 'fame', band: 3, text: '粉黑大战常客，等着被流量反噬吧' },
    { id: 'RV-FAME-T3-6', face: 'fame', band: 3, text: '怎么哪都有她，烦死了' },
    { id: 'RV-FAME-T4-1', face: 'fame', band: 4, text: '年轻演员里我妈最喜欢她' },
    { id: 'RV-FAME-T4-2', face: 'fame', band: 4, text: '路人盘大是真的，一提%玩家名%长辈全都认识' },
    { id: 'RV-FAME-T4-3', face: 'fame', band: 4, text: '红毯顺序说明一切，%玩家名%走完，媒体相机才收' },
    { id: 'RV-FAME-T4-4', face: 'fame', band: 4, text: '地铁电梯里全是她，躲得过开屏也躲不了小区电梯' },
    { id: 'RV-FAME-T4-5', face: 'fame', band: 4, text: '她的咖位本来就没人质疑吧' },
    { id: 'RV-FAME-T5-1', face: 'fame', band: 5, text: '留学时老外同学能拼对%玩家名%名字，还能说出两部作品，这文化输出比一百个通稿都管用' },
    { id: 'RV-FAME-T5-2', face: 'fame', band: 5, text: '外媒开始念她的中文名了' },
    { id: 'RV-FAME-T5-3', face: 'fame', band: 5, text: '外网她的十年老粉一抓一大把，国际影响力这一块没得说' },
    { id: 'RV-FAME-T5-4', face: 'fame', band: 5, text: '当评委那几年入选片单质量都不错，眼光可以的。' },
    { id: 'RV-FAME-T5-5', face: 'fame', band: 5, text: '后辈简历上“与她合作过”能单开一行' },

    // ===== 口碑面（T1~T5，**正式文案 22 条**＝2026-10-07 用户亲笔逐字照录，四桶满格）=====
    // ⚠️ **T3（−100~100）⛔ 设文案**（用户「算了口碑-100~100就不设评价吧，感觉没什么好评的」）⇒ 这一档组池时筛出 0 条属设计内：
    //    ⛔ 特判跳过、⛔ 兜底补句子、⛔ 为它放宽别的档。判据见 `ReviewSystem.repBand()`。
    { id: 'RV-REP-T1-1', face: 'rep', band: 1, text: '看见她就跳过' },
    { id: 'RV-REP-T1-2', face: 'rep', band: 1, text: '整容怪去死' },
    { id: 'RV-REP-T1-3', face: 'rep', band: 1, text: '%玩家名%滚出娱乐圈' },
    { id: 'RV-REP-T1-4', face: 'rep', band: 1, text: '还有人粉%玩家名%吗？应该只剩黑粉了吧' },
    { id: 'RV-REP-T1-5', face: 'rep', band: 1, text: '粉过她是我的赛博案底' },
    { id: 'RV-REP-T2-1', face: 'rep', band: 2, text: '讨论她的帖子一楼就在吵咖位，没几个人聊作品' },
    { id: 'RV-REP-T2-2', face: 'rep', band: 2, text: '她霸凌同学那事是真的吗？' },
    { id: 'RV-REP-T2-3', face: 'rep', band: 2, text: '每次发言都能精准踩中雷区真服了' },
    { id: 'RV-REP-T2-4', face: 'rep', band: 2, text: '看见她就烦' },
    { id: 'RV-REP-T2-5', face: 'rep', band: 2, text: '营销翻车，公关灾难，好好笑' },
    { id: 'RV-REP-T2-6', face: 'rep', band: 2, text: '黑红也是红' },
    { id: 'RV-REP-T4-1', face: 'rep', band: 4, text: '她合作过的朋友说她事少，这话在这个圈里算好话了' },
    { id: 'RV-REP-T4-2', face: 'rep', band: 4, text: '群演说%玩家名%没架子，等戏的时候不赶人，也不突然改走位。' },
    { id: 'RV-REP-T4-3', face: 'rep', band: 4, text: '好几个合作过的老演员都说过她敬业' },
    { id: 'RV-REP-T4-4', face: 'rep', band: 4, text: '不争不抢挺好的' },
    { id: 'RV-REP-T4-5', face: 'rep', band: 4, text: '后援会不集资不催氪，生日应援是公益捐书，这点让我挺有好感的' },
    { id: 'RV-REP-T4-6', face: 'rep', band: 4, text: '她好像没什么黑料' },
    { id: 'RV-REP-T5-1', face: 'rep', band: 5, text: '%玩家名%最大的黑料是太老好人' },
    { id: 'RV-REP-T5-2', face: 'rep', band: 5, text: '%玩家名%工作室每年都会呼吁粉丝不用应援，把钱花自己身上' },
    { id: 'RV-REP-T5-3', face: 'rep', band: 5, text: '她是我大学学姐，大一入学的时候帮我拎过箱子，人真的特别温柔' },
    { id: 'RV-REP-T5-4', face: 'rep', band: 5, text: '%玩家名%一直是公认的敬业' },
    { id: 'RV-REP-T5-5', face: 'rep', band: 5, text: '制片人最喜欢的演员，工作专业，配合度也高，只要合作过没有不夸的' },

    // ===== 🚫 事件桶整块下线（2026-10-07 用户两道令）=====
    // 五桶文案与判据全删（扑街／爆红／公益＝「连机制一起拆吧，因为你写的判据不太合理」；获奖／塌房＝「先不写 游戏里也不要实装，
    // 这两个事件的评论可能要根据卡位的不同写不同的评论才合理，有点麻烦」）⇒ `ReviewFace` 撤掉 'event'、`EventKind`/`evKind`/`activeEvents()` 一并删。
    // 重做前置项＝按咖位分档重设计判据与文案（文案在 git 里，`036f758`~`0c98eb2` 任一版可取）。

// 近作反响（原 RV-NR-* 18 条）2026-10-31 整块下线，见文件头注释。
];
